/** @format */
import * as yup from "yup";

// const passwordRules = /^(?=.{4,10})(?=.*[a-z])([/\s/g] )/g;
const passwordRules = /\S/g


export const registerSchema = yup.object().shape({
  email: yup.string().email("Please enter email").required("Email is required"),
  password: yup
    .string()
    .min(4, "Password must be at least 4 characters")
    .matches(passwordRules, {
      message: "Password has space.",
    })
    
    .required("Password is required"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), undefined], "Password Don't Match")
    .required("Retype Password is required"),
});
